import { z } from "zod";

/**
 * Cancel Slack Pending App — Path Variables
 *
 * Used by DELETE /api/slack/pending-app/:deploymentId
 */
export const CancelSlackPendingAppPathVarsSchema = z.object({
  deploymentId: z.string().uuid()
});

export type CancelSlackPendingAppPathVars = z.infer<typeof CancelSlackPendingAppPathVarsSchema>;

/**
 * Cancel Slack Pending App — Response
 *
 * cancelled: true  = pending app was cleared
 * cancelled: false = no pending app existed (idempotent)
 */
export const CancelSlackPendingAppResponseSchema = z.object({
  cancelled: z.boolean()
});

export type CancelSlackPendingAppResponse = z.infer<typeof CancelSlackPendingAppResponseSchema>;
